import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import ChooseConsultant from './components/ChooseConsultant/ChooseConsultant'
import SettingsScreen from '../Settings/SettingsScreen'
import I18n from 'i18n-js'

const Screen = (props) => {
	const { counseling_center_username } = useSelector(state => state.FormReducer)

	useEffect(() => {
		const newPageTitle = `${counseling_center_username} ${I18n.t('settings.htmlTitle')} `
		document.querySelector('title').textContent
			= newPageTitle
	}, [])
	const {
		language,
		currency,
		timezone,
		startButton
	} = useSelector(state => state.SettingsReducer)

	return (
		<div>
			{language && currency && timezone && startButton === true && <ChooseConsultant/>}
			{(!language || !currency || !timezone || startButton === false) && <SettingsScreen/>}
		</div>
	)
}

export default Screen
